<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>运营回访统计</span>
          </div>

          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">客户编码</label>
              <el-input v-model.trim="searchData.id" class="jm-input280" />
            </div>
            <div class="box-content">
              <label class="form-tit">回访创建人</label>
              <el-select
                v-model="searchData.adminuid"
                filterable
                class="jm-input280"
                clearable
                placeholder="请选择">
                <el-option-group
                  v-for="(group, k) in ds.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.username"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">回访创建时间</label>
              <el-date-picker
                :editable="false"
                v-model="searchData.creationDate"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">回访类型</label>
              <jm-dict-select
                class="jm-input280"
                clearable
                type="dataset"
                v-model="searchData.visit_type"
                dict-type="visit"
                name="type"/>
            </div>
            <div class="box-content">
              <label class="form-tit">回访方式</label>
              <jm-dict-select
                clearable
                class="jm-input280"
                dict="dataset.visit.way"
                v-model="searchData.visit_kind"
              />
            </div>
            <div class="box-content">
              <label class="form-tit">资源创建时间</label>
              <el-date-picker
                :editable="false"
                v-model="searchData.student_create_time"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"/>
            </div>
            <div class="box-content" v-if="isFibSite">
              <label class="form-tit">客户分级</label>
              <jm-dict-select
                class="jm-input280"
                clearable
                type="dataset"
                v-model="searchData.customerClassification"
                dict-type="student"
                name="customLvType"
              />
            </div>
            <div class="box-content" v-else-if="isTrainingSite">
              <label class="form-tit">客户状态</label>
              <jm-dict-select
                class="jm-input280"
                clearable
                type="dataset"
                v-model="searchData.customerClassification"
                dict-type="training"
                name="trainingLevelType"
              />
            </div>
            <div class="box-content">
              <label class="form-tit">活动编码</label>
              <el-input
                v-model="searchData.activity_code"
                class="jm-input280"/>
            </div>
            <div class="box-content" v-if="isFibSite">
              <label class="form-tit">入学时间</label>
              <div style="display:inline-block;">
                <el-date-picker
                  :editable="false"
                  v-model="searchData.startSchoolDateYear"
                  @change="() => { this.searchData.startSchoolDateMonth = ''; }"
                  type="year"
                  placeholder="请选择"
                  class="jm-input135"
                  format="yyyy"
                  value-format="yyyy"/>
                <el-date-picker
                  :editable="false"
                  v-model="searchData.startSchoolDateMonth"
                  :disabled="!searchData.startSchoolDateYear"
                  type="month"
                  placeholder="请选择"
                  class="jm-input135"
                  popper-class="process-list-popper"
                  format="MM"
                  value-format="MM"/>
              </div>
            </div>
            <div class="box-content" v-else-if="isTrainingSite">
              <label class="form-tit">签约日期</label>
              <el-date-picker
                :editable="false"
                v-model="searchData.signingdate"
                value-format="yyyy-MM-dd"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"/>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">渠道来源</label>
              <jm-channel
                v-model="searchData.channel"
                clearable
                filterable/>
            </div>
            <div class="box-content" v-if="$hasPermission([1, 62]) && isFibSite">
              <label class="form-tit">业务部门</label>
              <el-select
                v-model="searchData.department"
                class="jm-input280"
                filterable
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in ds.departments"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </div>
            <div class="box-content" v-if="isFibSite">
              <label class="form-tit">咨询顾问</label>
              <el-select
                v-model="searchData.crm_sayer"
                class="jm-input280"
                clearable
                placeholder="请选择"
                filterable>
                <el-option-group
                  v-for="(group, k) in ds.advisory_teacher"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="`${item.country}_${item.userid}`"
                    :label="item.truename"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content" v-else-if="isTrainingSite">
              <label class="form-tit">咨询顾问</label>
              <el-select
                v-model="searchData.crm_sayer"
                class="jm-input280"
                clearable
                placeholder="请选择"
                filterable>
                <el-option-group v-for="(group, k) in ds.training_teacher" :key="k" :label="k">
                  <el-option
                    v-for="item in group"
                    :key="`${item.country}_${item.userid}`"
                    :label="item.truename"
                    :value="item.userid"
                  />
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content" v-if="isFibSite">
              <label class="form-tit">意向国家</label>
              <jm-dict-select
                class="jm-input280"
                clearable
                v-model="searchData.intentionCountries"
                type="online"
                dict-type="country"
              />
            </div>
            <div class="box-content" v-if="isTrainingSite">
              <label class="form-tit">运营情况</label>
              <jm-dict-select
                placeholder="请选择"
                class="jm-input280"
                clearable
                filterable
                v-model="searchData.opStatus"
                dict="dataset.student.opStatus">
              </jm-dict-select>
            </div>
            <div class="box-content">
              <label class="form-tit">
                是否去重
                <el-tooltip placement="bottom-start" effect="light">
                  <div slot="content">
                    如果有多条相同重复进入创建人的记录，默认去除重复记录，仅显示最后进入的记录。<br />开启重复，会显示多条相同结果。
                  </div>
                  <i class="el-icon-question blue"/>
                </el-tooltip>
              </label>
              <el-switch
                v-model="searchData.not_duplicate"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </div>
          </div>

          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => { this.refresh = true }">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input-common3"
              v-if="$hasPermission([1, 62, 99, 100])"
              type="success"
              :loading="exporting"
              @click="exportVisit">导出数据</el-button>
          </div>

          <jm-tableList
            :url="`/${model}/operate_visit/searchList`"
            :search-data="searchData"
            :refresh.sync="refresh">
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="80"
              align="center">
              <template slot-scope="scope">
                <div v-if="isFibSite">
                  <router-link
                    target="_blank"
                    :to="{name:'editStudent', params: { id: scope.row.userid }}">
                    <el-button
                      type="primary"
                      size="small">查 看</el-button>
                  </router-link>
                </div>
                <div v-else-if="isTrainingSite">
                  <router-link
                    target="_blank"
                    :to="{name:'resourceEdit', params: { id: scope.row.userid }}">
                    <el-button
                      type="primary"
                      size="small">查 看</el-button>
                  </router-link>
                </div>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect, } from '@/components/tool/index.js';
import { formatSelectGroupData } from '@/utils/utils.js';
import ElRow from 'element-ui/packages/row/src/row';
import { jmChannel } from '@/components/tool';
import student from './student';

const defaultSearchData = function () {
  return {
    id: '',
    adminuid: '',
    creationDate: [],
    department: '',
    visit_type: '',
    visit_kind: '',
    student_create_time: [],
    startSchoolDateYear: '', // 入学日期
    startSchoolDateMonth: '', // 入学日期
    customerClassification: '', // 客户分级
    activity_code: '', // 活动编号
    // 渠道
    channel: {
      custom_from: '',
      custom_from_sub: '',
      custom_from_thrid: '',
      custom_from_fourth: '',
      custom_from_fifth: ''
    },
    crm_sayer: '', // 咨询老师
    intentionCountries: '0', // 意向国家
    opStatus: '', // 运营状态
    signingdate: '', // 签约日期
  };
};

export default {
  data() {
    return {
      searchData: defaultSearchData(),
      refresh: false,
      ds: {},
      exporting: false,
      model: 'index'
    };
  },
  components: {
    ElRow,
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
    jmChannel,
  },
  computed: {
  },
  mixins: [student],
  methods: {
    resetFields() {
      this.searchData = defaultSearchData();
      // Object.keys(this.searchData).forEach((k) => {
      //   if (typeof this.searchData[k] !== 'object') {
      //     this.searchData[k] = '';
      //   }
      // });
      // this.searchData.channel.custom_from = '';
      // this.searchData.creationDate = [];
      // this.searchData.student_create_time = [];
      this.$store.commit('updateRefresh', true);
    },
    getDatasource() {
      this.$http._get({
        url: '/index/Visit/searchDs',
      }).then((response) => {
        this.ds = response.data;
        // 创建人
        this.ds.create_person = formatSelectGroupData(this.ds.create_person);
        // 咨询
        this.ds.advisory_teacher = this.formatTeacher(this.ds.advisory_teacher);
        // 考培咨询
        this.ds.training_teacher = this.formatTeacher(this.ds.training_teacher);
      });
    },
    exportVisit() {
      this.exporting = true;
      this.$http._post({
        url: `/${this.model}/operate_visit/exportVisit`,
        data: this.searchData,
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '回访记录.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    },
  },
  mounted() {
    if (this.$siteName !== 'fib') {
      this.model = this.$siteName;
    }
    this.getDatasource();
  },
};
</script>
<style scoped>
  .basic-paddingssss {
    padding: 20px 10px;
    text-align: left;
  }
  .search-btn{
    clear: both;
    text-align: center;
    padding: 20px 0 30px;
  }
</style>
